import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor() { }

  searchAndEmit(
    filterInfo: any,
    searchData: any,
    eventEmitterFn: () => void,
    searchQuery: any
  ): void {
    let matched = false;

    if (filterInfo) {
      const {union, offset, limit, sort} = filterInfo.dto;

      for (let i = 0; i < union.length; i++) {
        const unionFilters = union[i]?.filter?.filters;
        const isOr = union[i]?.filter?.logic === "or";

        // track matches in the current union block
        let unionMatched = isOr ? false : true;

        if (unionFilters) {
          for (let j = 0; j < unionFilters.length; j++) {
            const {field, value, operator} = unionFilters[j];

            // compare search data to filter criteria
            const searchValue = searchData[field];
            let filterMatched = false;

            if (searchValue) {
              switch (operator) {
                case "eq":
                  filterMatched = searchValue === value;
                  break;
                case "neq":
                  filterMatched = searchValue !== value;
                  break;
                case "lt":
                  filterMatched = searchValue < value;
                  break;
                case "lte":
                  filterMatched = searchValue <= value;
                  break;
                case "gt":
                  filterMatched = searchValue > value;
                  break;
                case "gte":
                  filterMatched = searchValue >= value;
                  break;
                case "startswith":
                  filterMatched = searchValue?.startsWith(value);
                  break;
                case "endswith":
                  filterMatched = searchValue?.endsWith(value);
                  break;
                case "contains":
                  filterMatched = searchValue?.includes(value);
                  break;
                case "doesnotcontain":
                  filterMatched = !searchValue?.includes(value);
                  break;
                case "reversecontains":
                  filterMatched = value?.includes(searchValue);
                  break;
                default:
                  filterMatched = true; // ignore unknown operators
                  break;
              }
            }


            // update unionMatched based on filter match and operator logic
            if (isOr && filterMatched) {
              unionMatched = true;
            } else if (!isOr && !filterMatched) {
              unionMatched = false;
              break; // short-circuit if AND operator and filter doesn't match
            }
          }
        }

        // update matched flag based on unionMatched and operator logic
        if (isOr && unionMatched) {
          matched = true;
        } else if (!isOr && unionMatched) {
          matched = true;
        } else if (!isOr && !unionMatched) {
          matched = false;
          break; // short-circuit if all union blocks must match but this one doesn't
        }
      }

    }

    // Compare searchData values with searchQuery
    const searchValues = Object.values(searchData).map(value => String(value));
    if (searchQuery && searchValues.some(value => value.includes(searchQuery))) {
      matched = true;
    }

    // emit event if all filters matched
    if (matched || !searchQuery) {
      eventEmitterFn();
    }
  }

}
